import { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import { SLIDE_OUT_TIMEOUT } from '../../../constants';

interface Props {
  children: ReactNode;
  showing?: boolean;
}

export const Transition = ({ children, showing = false }: Props) => (
  <CSSTransition in={showing} unmountOnExit timeout={SLIDE_OUT_TIMEOUT}>
    {children}
  </CSSTransition>
);
